<template>
    <v-overlay color="#000" opacity="0.5" :z-index="9999" :value="value" absolute>
        <v-progress-circular color="#ccc" indeterminate size="128" />
    </v-overlay>
</template>
<script>
    export default {
        props: { value: Boolean }
    }
</script>
